// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__21bn8","header":"ReportDetails_header__1HD96","title":"ReportDetails_title__T56Vn","left":"ReportDetails_left__11DSS"};